// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@werner/App/Widgets/Baic/Carousel";
import { slideshowStyles } from "@werner/Overrides/Widgets/Basic/Slideshow";
import { css } from "styled-components";

carouselStyles.titleText = {
    variant: "h2",
    transform: "capitalize",
    css: css`
        margin-bottom: 25px;
    `,
};

carouselStyles.slideshowWrapper = { ...slideshowStyles.slideshowWrapper };

carouselStyles.prevArrowWrapper = { ...slideshowStyles.prevArrowWrapper };

carouselStyles.iconProps = { ...slideshowStyles.iconProps };

carouselStyles.carouselContainer = {
    css: css`
        overflow: hidden;
    `,
};

carouselStyles.slideContainerWrapper = { ...slideshowStyles.slideContainerWrapper };

carouselStyles.slideContentWrapper = {
    css: css`
        display: flex;
        flex: 0 0 100%;
        position: relative;
    `,
};

carouselStyles.slideOverlayWrapper = {
    css: css`
        width: 100%;
    `,
};

carouselStyles.dotsContainerWrapper = { ...slideshowStyles.dotsContainerWrapper };

carouselStyles.dotButton = { ...slideshowStyles.dotButton };

carouselStyles.nextArrowWrapper = { ...slideshowStyles.nextArrowWrapper };
